import useQuestionnaireFormContext from '../QuestionnaireFormProvider/useQuestionnaireFormContext';
import useQuestionnaireInspector from './useQuestionnaireInspector';

const QuestionnaireInspector: React.FC<{
  fieldsByKey: Parameters<typeof useQuestionnaireInspector>[0]['fieldsByKey'];
  formMethods: Parameters<typeof useQuestionnaireInspector>[0]['formMethods'];
  sections: Parameters<typeof useQuestionnaireInspector>[0]['sections'];
}> = ({
  fieldsByKey,
  formMethods,
  sections,
}) => {
  const {
    getResponseSource,
  } = useQuestionnaireFormContext();
  useQuestionnaireInspector({
    fieldsByKey,
    formMethods,
    getResponseSource,
    sections,
  });
  return null;
};

export default QuestionnaireInspector;